import { Action } from "../../types"

export interface genericFilterType { 
    [key:string]:string | string[]
}

const initialState:genericFilterType = {
}
export function genericFilterReducer(state:genericFilterType=initialState,action:Action<genericFilterType>):genericFilterType{
    switch(action.type){
        case "updateGenericFilter":
            return {...state,...action.payload}; 
        case "resetGenericFilter":
            return {...action.payload};
        case "clearGenericFilter":
            return {...initialState};
    }
    return state
}
